import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import MarketingHeader from '../../components/MarketingHeader';
import { useDecideSocialPostApproval, useSocialPosts } from '../../hooks/useSocial';
import { DangerButton, SecondaryButton } from '../../styles/marketingSharedStyles';
import { Card, CardTitle, Input, Item, List, Page, Row, Subtle } from './socialStyles';

const SocialApprovalsPage: React.FC = () => {
  const posts = useSocialPosts();
  const decide = useDecideSocialPostApproval();
  const [comment, setComment] = useState('');

  const pending = useMemo(
    () => (posts.data ?? []).filter((post) => post.workflow_status === 'pending_approval'),
    [posts.data]
  );

  return (
    <Page>
      <MarketingHeader activeTab="social" />
      <Card>
        <CardTitle>Approval Queue</CardTitle>
        <Subtle>Review drafts submitted by marketing/admin before they can be scheduled or published.</Subtle>
      </Card>

      <Card>
        <Row>
          <Input
            placeholder="Optional comment for approval decision"
            value={comment}
            onChange={(event) => setComment(event.target.value)}
          />
        </Row>
        {posts.isLoading ? (
          <Subtle>Loading approvals...</Subtle>
        ) : (
          <List>
            {pending.map((post) => (
              <Item key={post.id}>
                <Row>
                  <strong>{post.title || 'Untitled Post'}</strong>
                  <span>{post.scheduled_for ? new Date(post.scheduled_for).toLocaleString() : 'Not scheduled'}</span>
                  <SecondaryButton
                    type="button"
                    onClick={() => decide.mutate({ postId: post.id, decision: 'approved', comment })}
                    disabled={decide.isPending}
                  >
                    Approve
                  </SecondaryButton>
                  <DangerButton
                    type="button"
                    onClick={() => decide.mutate({ postId: post.id, decision: 'rejected', comment })}
                    disabled={decide.isPending}
                  >
                    Reject
                  </DangerButton>
                  <Link to={`/marketing/social/composer/${post.id}`}>Open</Link>
                </Row>
              </Item>
            ))}
            {pending.length === 0 ? <Subtle>No posts awaiting approval.</Subtle> : null}
          </List>
        )}
      </Card>
    </Page>
  );
};

export default SocialApprovalsPage;
